<template lang="pug">
b-row
    b-col.my-3.my-lg-5.px-0.px-md-3(lg="8", offset-lg="2")
        Card(
            :title="company.title",
            :backLink="true",
            :text="company.details[0].description_detail",
            :image="company.image",
            :contactButton="company.details[0].email ? `mailto:${company.details[0].email}` : false"
        )
        Card(
            v-for="(offer, idx) in activeOffers",
            :key="`company-${offer.id}-offer-${idx}`",
            :title="offer.title",
            :subtitle="offer.location",
            :text="offer.description_short",
            :showMore="true",
            style="cursor: pointer",
            :url="{ name: 'offer', params: { companyId, offerId: offer.id } }"
        )
        Card(
            v-for="(offer, idx) in closedOffers",
            :key="`company-${offer.id}-offer-${idx}`",
            :title="offer.title",
            :subtitle="offer.location",
            :text="offer.description_short",
            :showMore="true",
            style="cursor: pointer",
            :url="{ name: 'offer', params: { companyId, offerId: offer.id } }"
            additionalClasses="closed no-hover"
            :closed="true"
        )
</template>

<script>
import Card from "@/components/CardComponent.vue";
export default {
    name: "CompanyDetailPage",
    components: { Card },
    computed: {
        companyId() {
            return this.$router.history.current.params.companyId;
        },
        company() {
            return this.$store.getters.companyById(this.companyId);
        },
        activeOffers() {
            return this.$store.getters.companyActiveOffers(this.companyId);
        },
        closedOffers() {
            return this.$store.getters.companyClosedOffers(this.companyId);
        },
    },
};
</script>
